<header class="sign-header">
  <div class="header-top-row">
    <img [src]="headerLogoSrc()" class="header-logo" />
    @if(pdfEditState.showToolsInHeader()) {
      <div class="header-pdf-tools-wrap">
        <div class="header-pdf-tools">
          <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'esign'" [class.disabled]="isAllReviewers()"
            [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('esign')" (dragstart)="onHeaderToolDragStart($event, 'esign')">
            <mat-icon>edit</mat-icon><span>{{ t('signature') }}</span>
          </div>
          <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'comment'" [class.disabled]="false"
            draggable="true" (click)="onHeaderToolClick('comment')" (dragstart)="onHeaderToolDragStart($event, 'comment')">
            <mat-icon>comment</mat-icon><span>{{ t('comment') }}</span>
          </div>
          <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'initials'" [class.disabled]="isAllReviewers()"
            [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('initials')" (dragstart)="onHeaderToolDragStart($event, 'initials')">
            <mat-icon>short_text</mat-icon><span>{{ t('initials') }}</span>
          </div>
          <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'text'" [class.disabled]="isAllReviewers()"
            [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('text')" (dragstart)="onHeaderToolDragStart($event, 'text')">
            <mat-icon>text_fields</mat-icon><span>{{ t('text') }}</span>
          </div>
          <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'date'" [class.disabled]="isAllReviewers()"
            [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('date')" (dragstart)="onHeaderToolDragStart($event, 'date')">
            <mat-icon>calendar_today</mat-icon><span>{{ t('date') }}</span>
          </div>
          @if(isMobileView) {
            @if(pdfEditState.mobileToolsExpanded()) {
              <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'checkbox'" [class.disabled]="isAllReviewers()"
                [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('checkbox')" (dragstart)="onHeaderToolDragStart($event, 'checkbox')">
                <mat-icon>check_box</mat-icon><span>{{ t('checkbox') }}</span>
              </div>
              <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'stamp'" [class.disabled]="isAllReviewers()"
                [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('stamp')" (dragstart)="onHeaderToolDragStart($event, 'stamp')">
                <mat-icon>image</mat-icon><span>{{ t('stamp') }}</span>
              </div>
              <div class="header-pdf-tool-item header-pdf-tool-more header-pdf-tool-more--icon-only" (click)="pdfEditState.toggleMobileToolsExpanded()">
                <mat-icon>expand_less</mat-icon><span class="header-pdf-tool-more-label">Less</span>
              </div>
            } @else {
              <div class="header-pdf-tool-item header-pdf-tool-more header-pdf-tool-more--icon-only" (click)="pdfEditState.toggleMobileToolsExpanded()">
                <mat-icon>expand_more</mat-icon><span class="header-pdf-tool-more-label">More</span>
              </div>
            }
          } @else {
            <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'checkbox'" [class.disabled]="isAllReviewers()"
              [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('checkbox')" (dragstart)="onHeaderToolDragStart($event, 'checkbox')">
              <mat-icon>check_box</mat-icon><span>{{ t('checkbox') }}</span>
            </div>
            <div class="header-pdf-tool-item" [class.selected]="pdfEditState.selectedTool() === 'stamp'" [class.disabled]="isAllReviewers()"
              [attr.draggable]="!isAllReviewers()" (click)="onHeaderToolClick('stamp')" (dragstart)="onHeaderToolDragStart($event, 'stamp')">
              <mat-icon>image</mat-icon><span>{{ t('stamp') }}</span>
            </div>
          }
        </div>
      </div>
    }
    @if(isSignToolbarActive && !isMobileView) {
      <div class="sign-header-toolbar">
        <div class="toolbarViewerLeft">
          <div class="toolbar__left-custom">
            @for(item of visibleToolbarItems; track item.key) {
            <div class="toolbar__left-custom-item" (click)="onToolbarItemClick(item)"
              (mouseenter)="onToolbarItemHover(item.key)" (mouseleave)="onToolbarItemHover(null)"
                [attr.draggable]="!isToolbarItemDisabled(item) ? true : null"
                (dragstart)="onToolbarItemDragStart($event, item)"
                [ngClass]="{'disabled': isToolbarItemDisabled(item)}">
              <img class="sign-toolbar-icon"
                [src]="hoveredToolbarKey === item.key ? toolbarIconActive(item) : toolbarIcon(item)" alt="" />
              <span>{{ t(item.labelKey) }}</span>
              </div>
            }
            @if(showMobileMoreToggle) {
              <div class="toolbar__left-custom-item more-toggle" (click)="toggleMobileToolbar()">
                <mat-icon color="primary">
                  {{ isMobileToolbarExpanded ? 'expand_less' : 'expand_more' }}
                </mat-icon>
              </div>
            }
          </div>
        </div>
        <div class="toolbarViewerRight">
          <div class="document-action-btn-container"></div>
        </div>
      </div>
    }
    @if(showViewBanner()) {
      <div class="view-mode-banner">
        <span class="view-mode-banner__status">{{ t('viewCompleted') }}</span>
        <span class="view-mode-banner__text">{{ t('viewNoFurtherAction') }}</span>
      </div>
    }
    @if(isSignToolbarActive || showViewBanner() || isCustomerLayout()) {
      <div class="header-sign-right">
        <!-- <button type="button" class="header-kapybara-btn" (click)="onKapybaraClick()" matTooltip="Kapybara Assistant"
          aria-label="Kapybara Assistant">
          <img src="assets/kapybara_header_icon.png" alt="Kapybara" class="header-kapybara-icon" />
          
        </button> -->
        <div class="header-lang">
          <img src="assets/language.png" alt="Language" />
          <select [value]="currentLanguage" (change)="onLanguageChange($event)" aria-label="Select language">
            <option value="en">English</option>
            <option value="nl">Dutch</option>
            <option value="es">Spanish</option>
            <option value="fr">French</option>
            <option value="de">German</option>
            <option value="hi">Hindi</option>
          </select>
        </div>
        @if(signerNameInitials()) {
          <div class="sign-header-user-profile">
            <span>{{signerNameInitials()}}</span>
          </div>
        }
      </div>
    }
  </div>
</header>